export const logsActions = {
    GET_LOGS: 'GET_LOGS',
    SET_LOGS: 'SET_LOGS',
    GET_SCHEMAS_FOR_LOG: 'GET_SCHEMAS_FOR_LOG',
    SET_SCHEMAS_FOR_LOG: 'SET_SCHEMAS_FOR_LOG',
    CLEAR_SCHEMAS_FOR_LOG: 'CLEAR_SCHEMAS_FOR_LOG'
};

const initState = {
    logs: [],
    schemas: undefined
};

export const logsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case logsActions.SET_LOGS:
            return Object.assign({}, state, action.payload);

        case logsActions.SET_SCHEMAS_FOR_LOG:
            const schemas = action.payload.schemas;
            return Object.assign({}, state, { schemas: Object.assign({}, state.schemas || {}, schemas) });

        case logsActions.CLEAR_SCHEMAS_FOR_LOG:
            state.schemas = null;
            return Object.assign({}, state);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/logsReducer.ts